import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppointmentService } from 'src/app/services/appointment.service';
import { FormBuilder, FormGroup, Validators,AbstractControl, ValidatorFn } from '@angular/forms';
import { AuthenticationService } from 'src/app/services/authentication.service';


function requiredNonWhitespaceValidator(control: AbstractControl): {[key: string]: any} | null {
  const isWhitespace = (control.value || '').trim().length === 0;
  const isValid = !isWhitespace;
  return isValid ? null : { 'requiredNonWhitespace': true };
}

function passwordValidator(): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const password = control.value;

    if (!password || password.length === 0) {
      return { 'requiredPass': true };
    } else if (password.length < 6) {
      return { 'invalidPassLength': true };
    } else {
      
      return null;
    }
  };
}
function confirmPasswordValidator(controlName: string, matchingControlName: string): Validators {
  return (formGroup: FormGroup): Validators | null => {
    const control = formGroup.get(controlName);
    const matchingControl = formGroup.get(matchingControlName);

    if (!control || !matchingControl) {
      return null;
    }

    return control.value === matchingControl.value ? null : { 'passwordMismatch': true };
  };
}
@Component({
  selector: 'app-create-admin-user',
  templateUrl: './create-admin-user.component.html',
  styleUrls: ['./create-admin-user.component.scss']
})
export class CreateAdminUserComponent implements OnInit {
  successMessage: string = '';
  failureMessage: string = '';
  message!: string;
  user!: string;
  locations: any = [];
  error: boolean = false;
  passf = false;
  fail=false;
  invalid=false;

  constructor(
    private auth: AuthenticationService,
    private formBuilder: FormBuilder,
    private appointment: AppointmentService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
  }

  userForm!: FormGroup;
  confPass: string = '';
  pass: string = '';


  ngOnInit() {
    //  this.user=history.state['user'];
    const user = this.activatedRoute.snapshot.queryParamMap.get('user');
    if (user != null) {
      this.user = user;
    }


    this.appointment.getLocations().subscribe((res) => {
      this.locations = res;
    });
   
    let emailPattern = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$";



    this.userForm = this.formBuilder.group({
      locationId: [''],
      username: ['', Validators.required],
      firstName: ['', Validators.required],
      lastName: ['', [Validators.required, requiredNonWhitespaceValidator]],
      password: ['', [Validators.required, passwordValidator()]],
      confirmPassword: ['', [Validators.required, Validators.minLength(6)]],
      mobileNo: ['', Validators.required],
      email: ['', [Validators.required, Validators.pattern(emailPattern)]],    
      role: [''],
    }, { validators: confirmPasswordValidator('password', 'confirmPassword') });
   
    this.trimInputValue(this.userForm.get('lastName'));

    const mobileNoControl = this.userForm.get('mobileNo');

  }

  // Utility method to subscribe to a form control and trim its input
private trimInputValue(control: AbstractControl | null) {
  control?.valueChanges.subscribe(value => {
      if (typeof value === 'string') {
          control.setValue(value.trim(), { emitEvent: false });
      }
  });
}
 

  
  get f() { return this.userForm.controls; }


  routerBack() {
    
      this.router.navigate(['../admin']);
    
  }
  submit() {
    this.failureMessage ='';
    console.log("Form Submitted", this.userForm.value);
    if (this.userForm.invalid) {
      Object.keys(this.f).forEach(field => {
        const control = this.userForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
      this.failureMessage = 'All fields are required. Please ensure all fields are filled out correctly.';
      return;
    }

    // Check password confirmation
    if (this.userForm.value.password !== this.userForm.value.confirmPassword) {
      this.failureMessage = 'Passwords do not match.';
      return;
    }
    let role = ['ADMIN'];
    this.userForm.controls['role'].setValue(role);
    this.userForm.controls['locationId'].setValue(1);
    let createUserDetail = this.userForm.value;

    this.auth.createUser(createUserDetail).subscribe(
      (res: any) => {
        if (res.code === '200') {
          this.successMessage = 'Admin Created Successfully';
          setTimeout(() => {
            this.router.navigate(['../admin']);
          }, 2500);
        } else {
          this.failureMessage = 'An error occurred while creating the admin. ' + res.message;
        }
      },
      (err) => {
        console.error('Error during admin creation:', err);
        this.failureMessage = 'An unexpected error occurred. Please try again.';
      }
    );

  }
}
